/* eslint-disable react/jsx-filename-extension */
import React from "react"

interface DeleteThinIconProps {
  className?: string
  width?: string
  height?: string
  stroke?: string
  strokeWidth?: string
}

function DeleteThinIcon(props: Readonly<DeleteThinIconProps>) {
  const { className, width, height, stroke, strokeWidth } = props
  const cssClassName = className ?? ""
  const cssWidth = width ?? "24"
  const cssHeight = height ?? "24"
  const cssStroke = stroke ?? "currentColor"
  const cssStrokeWidth = strokeWidth ?? "1.5"
  return (
    <span className="anticon anticon-delete-thin-icon">
      <svg
        className={cssClassName}
        width={cssWidth}
        height={cssHeight}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5 10.2197V18.9997C19.5 20.9997 19 21.9997 16.5 21.9997H7.5C5 21.9997 4.5 20.9997 4.5 18.9997V10.2197"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 2H19C21 2 22 3 22 5V7C22 9 21 10 19 10H5C3 10 2 9 2 7V5C2 3 3 2 5 2Z"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default DeleteThinIcon
